import client from './client';

export async function fetchDashboard(params) {
  const response = await client.get('/api/dashboard', { params });
  return response.data;
}

export async function fetchTrends() {
  const response = await client.get('/api/dashboard/trends');
  return response.data;
}

export async function fetchByProvider() {
  const response = await client.get('/api/dashboard/by-provider');
  return response.data;
}
